import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './i18n/locales/en.json';
import ar from './i18n/locales/ar.json';

const resources = {
  en: { translation: en },
  ar: { translation: ar },
};

const applyDocumentLanguage = (language) => {
  const resolvedLanguage = (language || 'en').split('-')[0];
  document.documentElement.setAttribute('lang', resolvedLanguage);
  document.documentElement.setAttribute('dir', i18n.dir(resolvedLanguage));
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'ar'],
    load: 'languageOnly',
    cleanCode: true,
    debug: process.env.NODE_ENV === 'development',

    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },

    react: {
      useSuspense: false,
    },
  });

i18n.on('languageChanged', applyDocumentLanguage);
applyDocumentLanguage(i18n.resolvedLanguage || i18n.language);

export default i18n;
